import type { ReactElement } from 'react';
import { components, DropdownIndicatorProps } from 'react-select';
import { Icon } from '../../../icons/Icon.component';
import { SelectIconButton } from '../Select.styles';
import { ILegacySelectOptionData, LegacySelectComponentProps, LegacySelectOptionGroup } from '../Select.types';

type SelectDropdownIndicatorProps = LegacySelectComponentProps<
  DropdownIndicatorProps<ILegacySelectOptionData, boolean, LegacySelectOptionGroup>
>;

export const SelectDropdownIndicator = (props: SelectDropdownIndicatorProps): ReactElement => (
  <components.DropdownIndicator<ILegacySelectOptionData, boolean, LegacySelectOptionGroup> {...props}>
    <SelectIconButton variant={props.selectProps.variant}>
      <Icon icon={'chevron-down-regular'} size={10} />
    </SelectIconButton>
  </components.DropdownIndicator>
);

SelectDropdownIndicator.displayName = 'SelectDropdownIndicator';
